import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter} from "react-router-dom";
import {CssBaseline} from "@material-ui/core";
import BackendApi from "./BackendApi";
import {BackendContext} from './components/BackendContext';
import './styles.css';
import CartPage from "./pages/CartPage";
import AdminOptions from "./pages/AdminOptions";
import FloorPlansListing from "./pages/FloorPlansListing";
// import reportWebVitals from './reportWebVitals';

const nonce = document.querySelector('#nonce')?.getAttribute("value") || '',
    pageType = document.querySelector('#pageType')?.getAttribute("value") || '',
    floorPlanName = document.querySelector('#floorPlanName')?.getAttribute("value") || '';

const backendApi = new BackendApi(process.env.REACT_APP_WP || '/wp-json', nonce);

ReactDOM.render(
    <BackendContext.Provider value={backendApi}>
        <HashRouter>
            <CssBaseline/>
            {pageType === 'admin' ? <AdminOptions/>
                : floorPlanName ? <CartPage floorPlanName={floorPlanName}/>
                    : <FloorPlansListing/>}
        </HashRouter>
    </BackendContext.Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
